export const PAGE_NUMBER_OPTIONS = [
  {
    value: 5,
    text: 5
  },
  {
    value: 10,
    text: 10
  },
  {
    value: 20,
    text: 20
  },
  {
    value: 30,
    text: 30
  },
  {
    value: 50,
    text: 50
  },
  {
    value: 100,
    text: 100
  }
];
